import DevEndpoints from './endpoints.dev';
import ProdEndpoints from './endpoints.prod';
const Endpoints = __DEV__ ? DevEndpoints : ProdEndpoints;
export default Endpoints;
//# sourceMappingURL=endpoints.js.map